import { CustomerList } from '@components';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

type Props = RouteComponentProps;

const CustomerListPage: React.FC<Props> = ({ history }) => {
  const onSelect = (id: number) => {
    history.push(`/customers/${id}`);
  };
  return <CustomerList onSelect={onSelect} />;
};

export default CustomerListPage;
